export default {"src":"/_next/static/media/logo_switchit_teal.92dba6b3.svg","height":33,"width":61};